import { async } from '@angular/core/testing';
import { GenericVm } from './../models/system/generic-vm';
import { LoginUser } from './../models/DTO/LoginUser';
import { Globals } from 'src/app/shared/services/globals';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ConfigService } from './config.service';
import { AppStorageService } from './app-storage.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { HttpRequestService } from './http-request.service';
import { ThrowStmt } from '@angular/compiler';

@Injectable({
  providedIn: 'root'
})
export class UserManagerService {

  private _authNavStatusSource = new BehaviorSubject<boolean>(false);
  // Observable navItem stream
  authNavStatus$ = this._authNavStatusSource.asObservable();
  constructor(private configService: ConfigService, private appStore: AppStorageService,
              private router: Router, private http: HttpRequestService, private globals: Globals) { }

  logout() {
    this.appStore.removeItem(this.configService.getToken());
    this.appStore.removeItem(this.configService.getUserData());
    this._authNavStatusSource.next(false);
    if (environment.SSO === false) {
       this.router.navigateByUrl('/login');
    } else {
      window.location.href = environment.SSOLogoutUrl;
    }

  }

  saveToken(token) {

    this.appStore.setItem(this.configService.getToken(), token);
  }
  saveUserData(loginUser: LoginUser) {
    this.appStore.setItem(this.configService.getUserData(), JSON.stringify(loginUser));
  }

  getUserData() {
    return this.appStore.getItem(this.configService.getUserData());


  }



  getToken() {
    return localStorage.getItem(this.configService.getToken());
  }
  getApp() {
    return this.appStore.getItem(this.configService.getToken());
  }

  IsLoggedIn() {
    return this.getToken() !== null && this.getUserData() != null;

  }
  async isSSOLoginIn() {
    let ret;
    this.globals.afterloginspinner = true;
    await this.http.jsonp(environment.SSOUrl).toPromise().then(async res => {
      
      const hasRoles = await this.getSSOUserData(res['sid']);
     
      
      if (hasRoles === true) {
        this.saveToken(res['sid']);
        this.globals.afterloginspinner = false;
        ret = true;
      }
      this.globals.afterloginspinner = false;
      ret = false;
    }).catch(error => {
      this.globals.afterloginspinner = false;
      ret = false;
    });

    return ret;
  }
  async getSSOUserData(sid) {

    let ret;
    await this.http.postRequest('Auth/ssologin', sid).toPromise().then(
      result => {
        const gvm = (result as GenericVm<LoginUser>);

        if (gvm.status === 1) {
          this.saveUserData(gvm.data);
          
          ret = true;

        } else {
          this.globals.messages = gvm.messages;
          ret = false;
        }
      });
    return ret;

  }
  login() {
    this._authNavStatusSource.next(true);
  }

  async redirectToLogin() {

    let isSSOLoginIn;
    if (!environment.SSO) {
      this.router.navigate(['/login']);
    } else {
      await this.isSSOLoginIn().then(result => {
        isSSOLoginIn = result;

      });
      if (!isSSOLoginIn) {

        window.location.href = environment.SSOLoginUrl;

      } else {
        return true;
      }
    }
  }

}
